import { useEffect, useState } from 'react';
import { Breadcrumb, Button, Col, Input, message, Popconfirm, Row, Space, Table, Tooltip, Pagination } from 'antd';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { fetchArchiveVendorList, unArchiveVendor } from '../../slices/vendor';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { useDispatch, useSelector } from 'react-redux';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

function ArchiveVendor() {
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [orderBy, setOrderBy] = useState('');
    const [pagesize, setPageSize] = useState(10);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const { data = [], totalRecord = 0, status } = useSelector(state => state.vendor || {});

    useEffect(() => {
        dispatch(fetchArchiveVendorList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }));
    }, [dispatch, page, pagesize, search, orderBy]);

    const rowSelection = {
        selectedRowKeys,
        onChange: selectedKeys => {
            setSelectedRowKeys(selectedKeys);
        },
    };

    const handleSearch = e => {
        setSearch(e.target.value);
        setPage(1);
    };

    const resetFilter = () => {
        setSearch('');
        setPage(1);
        setOrderBy('');
    };

    const handlePageChange = newPage => {
        setPage(newPage);
    };

    const handlePageSizeChange = (current, size) => {
        setPage(1);
        setPageSize(size);
    };

    const GetSortingEnumValue = (sortField, sortOrder) => {
        let sortingEnumKey = "id";
        if (sortField === "udyam_aadhaar_no" && sortOrder === "ascend") {
            sortingEnumKey = "udyam_aadhaar_no";
        }
        if (sortField === "udyam_aadhaar_no" && sortOrder === "descend") {
            sortingEnumKey = "-udyam_aadhaar_no";
        }
        if (sortField === "vendor_trade_name" && sortOrder === "ascend") {
            sortingEnumKey = "vendor_trade_name";
        }
        if (sortField === "vendor_trade_name" && sortOrder === "descend") {
            sortingEnumKey = "-vendor_trade_name";
        }
        if (sortField === "vendor_code_as_per_company_erp" && sortOrder === "ascend") {
            sortingEnumKey = "vendor_code_as_per_company_erp";
        }
        if (sortField === "vendor_code_as_per_company_erp" && sortOrder === "descend") {
            sortingEnumKey = "-vendor_code_as_per_company_erp";
        }
        if (sortField === "person_name" && sortOrder === "ascend") {
            sortingEnumKey = "person_name";
        }
        if (sortField === "person_name" && sortOrder === "descend") {
            sortingEnumKey = "-person_name";
        }
        if (sortField === "designation" && sortOrder === "ascend") {
            sortingEnumKey = "designation";
        }
        if (sortField === "designation" && sortOrder === "descend") {
            sortingEnumKey = "-designation";
        }
        if (sortField === "phone" && sortOrder === "ascend") {
            sortingEnumKey = "phone";
        }
        if (sortField === "phone" && sortOrder === "descend") {
            sortingEnumKey = "-phone";
        }
        if (sortField === "email" && sortOrder === "ascend") {
            sortingEnumKey = "email";
        }
        if (sortField === "email" && sortOrder === "descend") {
            sortingEnumKey = "-email";
        }

        if (sortField === "gst_no" && sortOrder === "ascend") {
            sortingEnumKey = "gst_no";
        }
        if (sortField === "gst_no" && sortOrder === "descend") {
            sortingEnumKey = "-gst_no";
        }
        if (sortField === "vendor_registered_name" && sortOrder === "ascend") {
            sortingEnumKey = "vendor_registered_name";
        }
        if (sortField === "vendor_registered_name" && sortOrder === "descend") {
            sortingEnumKey = "-vendor_registered_name";
        }
        if (sortField === "address" && sortOrder === "ascend") {
            sortingEnumKey = "address";
        }
        if (sortField === "address" && sortOrder === "descend") {
            sortingEnumKey = "-address";
        }
        return sortingEnumKey;
    };
    const handleTableChange = async (pagination, filters, sorter, ordering) => {
        if (sorter && sorter.columnKey && sorter.order) {
            const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
            setOrderBy(orderBy);
        }
        setPageSize(pagination.pageSize);
    };

    const dataSource = data.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: (page - 1) * pagesize + index + 1,
    }));

    const handleRestore = id => {
        if (!id) {
            message.error('Missing ID for deletion!');
            return;
        }

        dispatch(unArchiveVendor(id)).unwrap()
            .then(() => {
                message.success('Vendor Unarchived Successfully!');
                dispatch(fetchArchiveVendorList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }));
            })
            .catch(error => {
                if (typeof error === 'object' && error !== null) {
                    const messages = [];
                    for (const key in error) {
                        if (Array.isArray(error[key])) {
                            messages.push(`${key}: ${error[key].join(', ')}`);
                        }
                    }
                    if (messages.length > 0) {
                        message.error(messages.join('; '));
                    } else {
                        message.error('An unknown error occurred.');
                    }
                } else if (typeof error === 'string') {
                    message.error(error);
                } else if (error instanceof Error) {
                    message.error(error.message);
                } else {
                    message.error('An unknown error occurred.');
                }
            });
    };

    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            key: 'SrNo',
            sorter: false,
            width: 100,
        },
        {
            title: 'Legal Name of Business',
            dataIndex: 'vendor_registered_name',
            key: 'vendor_registered_name',
            sorter: true,
            render: (text) => text ? text : 'N/A',
            width: 100,
        },
        {
            title: 'Vendor Trade Name',
            dataIndex: 'vendor_trade_name',
            key: 'vendor_trade_name',
            sorter: true,
            width: 100,
            render: (text) => text ? text : 'N/A',
        },
        {
            title: 'Vendor Code',
            dataIndex: 'vendor_code_as_per_company_erp',
            key: 'vendor_code_as_per_company_erp',
            sorter: true,
            render: (text) => text ? text : 'N/A',
            width: 100,
        },
        {
            title: 'Person Name',
            dataIndex: 'person_name',
            key: 'person_name',
            sorter: true,
            render: (text) => text ? text : 'N/A',
            width: 100,
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
            render: (text) => text ? text : 'N/A',
            sorter: true,
            width: 100,
        },
        {
            title: 'Contact Number',
            dataIndex: 'phone',
            key: 'phone',
            sorter: true,
            width: 150,
            render: (record) => {
                return (
                    <span>+{record} </span>
                )
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: 200,
            render: (text) => text ? text : 'N/A',
            sorter: true,
        },
        {
            title: "Registered Business Address",
            dataIndex: "address1",
            key: "address1",
            width: 200,
            sorter: false,
            render: (text, record) => {
                const address = `${record?.registered_business_address_area || ""} 
                              ${record?.registered_business_address_building || ""} 
                              ${record?.registered_business_address_landmark || ""} 
                              ${record?.registered_business_address_city || ""} 
                              ${record?.registered_business_address_state || ""} 
                              ${record?.registered_business_address_country || ""}- 
                              ${record?.registered_business_address_pincode || ""}`
                    .trim()
                    .toUpperCase(); // Convert full address to uppercase

                return <span>{address ? address : "N/A"}</span>;
            },
        },
        {
            title: "Trading Address",
            dataIndex: "address2",
            key: "address2",
            sorter: false,
            width: 200,
            render: (text, record) => {
                const address = `${record?.trading_address_area || ""} 
                              ${record?.trading_address_building || ""} 
                              ${record?.trading_address_landmark || ""} 
                              ${record?.trading_address_city || ""} 
                              ${record?.trading_address_state || ""} 
                              ${record?.trading_address_country || ""}- 
                              ${record?.trading_address_pincode || ""}`
                    .trim()
                    .toUpperCase(); // Convert full address to uppercase

                return <span>{address ? address : "N/A"}</span>;
            },
        },
        {
            title: 'Archive At',
            dataIndex: 'updated_at',
            key: 'updated_at',
            sorter: true,
            width: 100,
            render: (record) => {
                return (
                    <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
                )
            }
        },
        {
            title: 'Archive By',
            dataIndex: 'updated_by',
            key: 'updated_by',
            width: 100,
            sorter: true,
            render: (record) => {
                return (
                    <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'} </span>
                )
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            fixed: 'right',
            width: 100,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Restore">
                        <Popconfirm
                            title="Are you sure you want to Unarchive this record?"
                            onConfirm={() => handleRestore(record.id)}
                            onCancel={() => message.info('Action cancelled')}
                            okText="Yes"
                            cancelText="No"
                        >
                            <ArchiveRestore className="ArchiverestorImg" />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
        },
    ];
    return (
        <>
            <div className='sticyaction'>
                <Row className="pagenamerow" justify="space-between" align="middle">
                    <Col>
                        <h2>Archived Vendors</h2>
                        <div className="bredcrumbwrp">
                            <Link to="/vendor-list" className="back">
                                <Back /> BACK
                            </Link>
                            <Breadcrumb
                                items={[
                                    { title: <Link to="/vendor-list">Vendors</Link> },
                                    { title: 'Archived Vendors' }
                                ]}
                            />
                        </div>
                    </Col>
                    <Col>
                        <Space size="middle">
                            <Input
                                placeholder="Search"
                                className='searchbox'
                                prefix={<SearchOutlined />}
                                value={search}
                                style={{ width: 200 }}
                                onChange={handleSearch}
                            />
                            <Link>
                                <Tooltip placement="top" title={'Reset Filter'}>
                                    <Button
                                        type="primary"
                                        disabled={!search}
                                        className="iconlink"
                                        onClick={resetFilter}
                                    >
                                        <FilterIcon />
                                    </Button>
                                </Tooltip>
                            </Link>
                        </Space>
                    </Col>
                </Row>
            </div>
            <Row gutter={[16, 16]}>
            </Row>
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 1, overflow: 'auto' }}>
                    <Table
                        //rowSelection={rowSelection}
                        dataSource={dataSource}
                        columns={columns}
                        loading={status === 'loading'}
                        pagination={false}
                        onChange={handleTableChange}
                        scroll={{
                            x: 1500,
                            y: 400,
                        }}
                    />
                </div>

                <div
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 1000,
                        background: '#fff',
                        padding: 10,
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Pagination
                        current={page}
                        pageSize={pagesize}
                        total={totalRecord}
                        showSizeChanger
                        onShowSizeChange={handlePageSizeChange}
                        pageSizeOptions={["20", "50", "100"]}
                        showTotal={total => `Total ${total} items`}
                        onChange={handlePageChange}
                        locale={{ items_per_page: 'Items / Page' }}
                    />
                </div>
            </div>
        </>
    )
}

export default ArchiveVendor
